import React, { Component } from 'react'

import Grid from '@material-ui/core/Grid';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import EtapaFoto from "./EtapaFoto";
import {useDispatch, useSelector} from "react-redux";



const useStyles = makeStyles(theme => ({
    mainGrid:{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-around'

    },

    etapaFoto: {
        display: 'flex',
        flexDirection:'row',
        flexwrap: 'wrap',
        // backgroundColor: 'red',
        padding: '12px',
        justifyContent: 'flex-start',
        alignContent: 'flex-start'

        // borderRadius: '15px',
        // borderColor: 'cyan',
        // borderWidth: '1px',
        // borderBlockStyle: "dashed"


        // width: '120px'

    },

}));

const EtapaCardList = (props) => {

        const { isLoading } = props;
        const classes = useStyles();
    const foto = useSelector( state => state.ordemServicoReducer.fotografiaPlanta);
    const tempoEtapas = useSelector(state => state.ordemServicoReducer.tempoEtapas);
    const processos = useSelector(state => state.i4.processos);
    const estacoesTrabalho = useSelector(state => state.i4.estacoesTrabalho);

        const dispatch = useDispatch();

        if ( !foto.situacaoAtual ||   foto.situacaoAtual.length == 0) { return (<React.Fragment/>)}



        let etapasArray = [];
        foto.situacaoAtual.map( os => {
           let ix = etapasArray.findIndex( e => e.estabelecimentoId === os.estabelecimentoId && e.etapaAtual === os.etapaAtual );
           if (ix < 0) {
               etapasArray.push({
                   ...os,

                   quantidadeOS : 1,
                   os: [os],
                   ordensServicoAtivas: [],
                   concluidos: 0,
                   tempoTotalEspera: (os.DTUltimaEtapa && new Date(os.DTUltimaEtapa).getFullYear() > 2000)  ?
                                          ((new Date().getTime() - new Date(os.DTUltimaEtapa).getTime())  )  : 0
               })
           } else {
               etapasArray[ix].quantidadeOS = etapasArray[ix].quantidadeOS + 1;
               etapasArray[ix].tempoTotalEspera =
                   (os.DTUltimaEtapa && new Date(os.DTUltimaEtapa).getFullYear() > 2000) ? ((etapasArray[ix].tempoTotalEspera? etapasArray[ix].tempoTotalEspera : 0) + (new Date().getTime() - new Date(os.DTUltimaEtapa).getTime())  )  :
                                      (etapasArray[ix].tempoTotalEspera? etapasArray[ix].tempoTotalEspera : 0);
               etapasArray[ix].os.push(os);
           }
        });


        foto.qtdeConcluidasPorEtapa.map( q => {
           let ix = etapasArray.findIndex( e=> e.estabelecimentoId === q.estabelecimentoId && e.etapaId === q.etapaId  );
            if (ix < 0) {
                etapasArray.push({
                    ...q,
                    quantidadeOS : 0,
                    os: [],
                    ordensServicoAtivas: [],
                    concluidos: q.quantidadeConcluidas,
                    tempoTotalEspera: 0
                })
            } else {
                etapasArray[ix].concluidos =  etapasArray[ix].concluidos  + q.quantidadeConcluidas;
            }
        });

        estacoesTrabalho.map( (est) => {
            let ix = etapasArray.findIndex( e=> e.estabelecimentoId === est.estabelecimentoId && e.etapaId === est.etapaId  );
            if (ix >= 0 && est.osId !== 0){
                etapasArray[ix].ordensServicoAtivas.push(est);
            }
        });

        const ixProcessoPadrao = processos.findIndex(p => p.id === 1);
        if (ixProcessoPadrao >=0) {
            console.log("processoPadrao", ixProcessoPadrao);
            let pe;
            etapasArray.map(et => {
                    pe = processos[ixProcessoPadrao].processoEtapas.find(pe => pe.etapaId === et.etapaId);
                    if (pe !== null) {
                        et.processoEtapa = pe;
                    }
                }
            );
        }

        etapasArray.sort(function (a, b) {
            var aSize = a.estabelecimentoId;
            var bSize = b.estabelecimentoId;
            var aLow = a.etapaId; //sequencia ; // a.etapaId
            var bLow = b.etapaId ; // b.etapaId;
            // console.log(aLow + " | " + bLow);

            if(aSize == bSize)
            {
                return (aLow < bLow) ? -1 : (aLow > bLow) ? 1 : 0;
            }
            else
            {
                return (aSize < bSize) ? -1 : 1;
            }
        });

   console.log("etapasArray", etapasArray);

        return (
            <React.Fragment>
                <Grid container className={classes.mainGrid}>

                    { etapasArray
                        .filter(e => e.ehNaoVisivel === 0)
                        .map( (e, ix) => {

                            let tempo = null;
                            if (tempoEtapas.length  >0  && e && e.etapaId) {
                                tempo = tempoEtapas.find(te => te.etapaId === e.etapaId &&
                                    te.medida === "TODAS MEDIDAS-validos");
                            }
                            //console.log("etapaCardList tempo ", tempo)

                         return (
                             <Grid container item key={ix} className={classes.etapaFoto}  xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <EtapaFoto key={ix} foto={e} index={ix} tempo={tempo}/>
                             </Grid>
                         );


                    }) }
                </Grid>
            </React.Fragment>
        );

}


export default (EtapaCardList);
